// Use this when passing variables from drupal
var timer = Date.now();
(function ($, Drupal, drupalSettings) {
  Drupal.behaviors.themeGlobalBehavior = {
    attach: function (context, settings) {

    }
  };

  $(window).on('load', function() {
    if ($('.detailinformation .field img').length > 0 ) {
      $('.detailinformation .field' ).each(function( index ) {
        var that = $(this);
        if ($(that).find('img').length > 0) {
          $(that).attr('style',  "background-image: url('" + $(this).find('img').attr('src')  +"');" );
          $(that).find('img').remove();
        }
      });
    }

    $('.showlogin').on('click', function(e){
      e.preventDefault();
      $('.loginwrapper').slideToggle();
    });

    if ($('.path-frontpage').length > 0) {
      $('.path-frontpage .view-activity-list.view-display-id-recent_activities_block .views-row').each(function() {
        var index = $(this).index();
        var height = $(this).height();
        var popHeight = $('.path-frontpage .view-display-id-most_popular_activities_block .views-row').eq(index).height();
        console.log(height, popHeight);
        if (popHeight > height) {
          $(this).css('height', popHeight + 'px');
        }
        else {
          $('.path-frontpage .view-display-id-most_popular_activities_block .views-row').eq(index).css('height', height + 'px');
        }
      });
    }

  });

})(jQuery, Drupal, drupalSettings);
